// Componente off-screen capturado pelo html2canvas
// offscreen=true (padrão): position fixed fora da viewport (ModalCelebracao)
// offscreen=false: position relative, usado dentro de wrapper overflow:hidden (ShareDesafioModal)
export default function DesafioShareCard({ desafio, parametroAntes, parametroDepois, conquista, cardRef, offscreen = true }) {
  const temAntesDepois = parametroAntes && parametroDepois;

  const posicao = offscreen
    ? { position: 'fixed', left: '-9999px', top: 0 }
    : { position: 'relative' };

  return (
    <div
      ref={cardRef}
      style={{
        ...posicao,
        width: 360,
        height: 640,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        padding: '40px 32px 32px',
        background: 'linear-gradient(145deg, #2f2b5f 0%, #7b5ea7 60%, #c8b6d9 100%)',
        boxSizing: 'border-box',
        fontFamily: "'DM Sans', sans-serif",
        overflow: 'hidden',
      }}
    >
      {/* Blobs */}
      <div style={{ position: 'absolute', top: -60, right: -60, width: 220, height: 220, borderRadius: '50%', background: 'rgba(255,255,255,0.07)', zIndex: 0 }} />
      <div style={{ position: 'absolute', bottom: -80, left: -60, width: 280, height: 280, borderRadius: '50%', background: 'rgba(255,255,255,0.05)', zIndex: 0 }} />

      {/* Header */}
      <div style={{ position: 'relative', zIndex: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: 20, fontWeight: 600, color: '#fff' }}>
          Clube do Eu
        </span>
        <span style={{ fontSize: 12, fontWeight: 300, color: 'rgba(255,255,255,0.7)', letterSpacing: '0.04em' }}>
          @oclubedoeu
        </span>
      </div>

      {/* Corpo */}
      <div style={{ position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 20, textAlign: 'center' }}>
        <div style={{ width: 40, height: 1, background: 'rgba(255,255,255,0.3)' }} />

        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <p style={{ fontSize: 11, fontWeight: 500, letterSpacing: '0.15em', color: 'rgba(255,255,255,0.65)', textTransform: 'uppercase', margin: 0 }}>
            Desafio concluído
          </p>
          <h2 style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: 30, fontWeight: 600, color: '#fff', margin: 0, lineHeight: 1.2 }}>
            {desafio?.desafio_nome || 'Desafio'}
          </h2>
          <p style={{ fontSize: 13, fontWeight: 300, color: 'rgba(255,255,255,0.8)', margin: 0 }}>
            {desafio?.duracao} dias de prática
          </p>
        </div>

        {/* Barra completa */}
        <div style={{ display: 'flex', gap: 4, justifyContent: 'center', flexWrap: 'wrap', maxWidth: 240 }}>
          {Array.from({ length: desafio?.duracao || 7 }, (_, i) => (
            <div key={i} style={{ width: 20, height: 5, borderRadius: 3, background: 'rgba(255,255,255,0.9)' }} />
          ))}
        </div>

        {/* Antes / Depois */}
        {temAntesDepois && (
          <div style={{
            background: 'rgba(255,255,255,0.12)',
            borderRadius: 12,
            padding: '14px 20px',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
          }}>
            {desafio?.parametro_label && (
              <p style={{ fontSize: 10, fontWeight: 500, letterSpacing: '0.12em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.6)', margin: 0 }}>
                {desafio.parametro_label}
              </p>
            )}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 16 }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'center' }}>
                <span style={{ fontSize: 10, color: 'rgba(255,255,255,0.5)' }}>Antes</span>
                <span style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: 16, fontWeight: 600, color: 'rgba(255,255,255,0.8)' }}>
                  {parametroAntes}
                </span>
              </div>
              <span style={{ color: 'rgba(255,255,255,0.4)', fontSize: 18 }}>→</span>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'center' }}>
                <span style={{ fontSize: 10, color: 'rgba(255,255,255,0.5)' }}>Agora</span>
                <span style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: 16, fontWeight: 600, color: '#fff' }}>
                  {parametroDepois}
                </span>
              </div>
            </div>
          </div>
        )}

        {!temAntesDepois && desafio?.frase_inspiradora && (
          <p style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: 17, fontStyle: 'italic', fontWeight: 400, color: 'rgba(255,255,255,0.85)', lineHeight: 1.5, margin: 0 }}>
            "{desafio.frase_inspiradora}"
          </p>
        )}

        <div style={{ width: 40, height: 1, background: 'rgba(255,255,255,0.3)' }} />

        {/* Badge conquistada */}
        {conquista && (
          <div style={{
            background: 'rgba(255,255,255,0.12)',
            borderRadius: 10,
            padding: '10px 16px',
            width: '100%',
            boxSizing: 'border-box',
            display: 'flex',
            alignItems: 'center',
            gap: 10,
          }}>
            <span style={{ fontSize: 22 }}>🏅</span>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 2, textAlign: 'left' }}>
              <span style={{ fontSize: 11, fontWeight: 500, color: 'rgba(255,255,255,0.6)', letterSpacing: '0.1em', textTransform: 'uppercase' }}>
                Conquista desbloqueada
              </span>
              <span style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: 16, fontWeight: 600, color: '#fff' }}>
                {conquista.name}
              </span>
            </div>
          </div>
        )}
      </div>

      {/* Footer */}
      <div style={{ position: 'relative', zIndex: 1, textAlign: 'center' }}>
        <p style={{ fontSize: 12, fontWeight: 300, color: 'rgba(255,255,255,0.55)', margin: 0, letterSpacing: '0.04em' }}>
          oclubedoeu.com.br
        </p>
      </div>
    </div>
  );
}
